import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 71140AD8-A0A6-45DD-9414-5DB2FBC875F1
 * name format-align-top
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-align-top.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatAlignTopIcon = createSvgIcon(<><path d="M13,15L15.5,17.5L16.92,16.08L12,11.16L7.08,16.08L8.5,17.5L11,15V21H13V15M3,3H21V5H3V3M3,7H13V9H3V7Z" /></>, 'FormatAlignTopIcon');
export default FormatAlignTopIcon